import _asyncToGenerator from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _defineProperty from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject;
import React from "react";
var __jsx = React.createElement;
import _regeneratorRuntime from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/** @format */

import { Fragment, useEffect, useState } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import { withRouter } from 'next/router';
import ScrollToTop from 'react-scroll-up';
import { getFavouritesCalloutCookie, setFavouritesCalloutCookie } from "../utils/sessionHelper";
import { queries } from "../data/queries";
import { Container, Button, Layout, Heart } from "../components/_global";
import MerchantList from "../components/Merchant/List";
import MerchantListNav from "../components/Merchant/List/Nav";
import config from "../utils/clientConfig";
import styled from 'styled-components';
import { colours, fontSizes, layoutSizes, zIndexes } from "../constants/css";
import useWindowDimensions from "../utils/useWindowDimensions";
var CardWrapper = styled.div.withConfig({
  displayName: "all-stores__CardWrapper",
  componentId: "sc-1hh6lnf-0"
})(["display:flex;flex-wrap:wrap;margin:1rem 0 2rem 0;overflow-x:hidden;margin-top:0;@media only screen and (min-width:", "){padding:1px;}z-index:1;"], layoutSizes.desktopWidth);
var LetterBar = styled.div.withConfig({
  displayName: "all-stores__LetterBar",
  componentId: "sc-1hh6lnf-1"
})(["background-color:", ";border-radius:4px;padding:2px 1rem;margin:3rem 0 2rem;font-size:", ";width:100%;display:block;scroll-margin-top:3em;@media only screen and (min-width:", "){&:first-child{margin-top:1rem;}}@media only screen and (max-width:", "){margin:0 0 0 0;height:1.5rem;line-height:1.5rem;border-radius:0;> div{margin-top:-9.5rem;height:9.5rem;visibility:hidden;pointer-events:none;}> span{font-size:0.875rem;display:block;}}"], colours.qantasIceWhite, fontSizes.xxl, layoutSizes.tabletAndDesktopWidth, layoutSizes.mobileWidth);
var HeartInCircle = function HeartInCircle() {
  return __jsx("span", {
    style: {
      verticalAlign: 'middle'
    }
  }, __jsx("svg", {
    width: "32px",
    version: "1.1",
    viewBox: "0 0 32 32",
    xmlns: "https://www.w3.org/2000/svg"
  }, __jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, __jsx("g", {
    transform: "translate(-1161 -14)"
  }, __jsx("g", {
    transform: "translate(1162 15)"
  }, __jsx("path", {
    cy: "5",
    id: "circle",
    d: "m0 15c0-8.2843 6.7139-15 15-15 8.2843 0 15 6.7139 15 15 0 8.2843-6.7139 15-15 15-8.2843 0-15-6.7139-15-15z",
    stroke: "#323232"
  }), __jsx("path", {
    cy: "5",
    id: "heart",
    d: "m20.862 11.19c-0.73458-0.76762-1.7111-1.19-2.75-1.19-1.039 0-1.911 0.42241-2.6458 1.19l-0.46669 0.52426-0.46664-0.52426c-0.73462-0.76762-1.6068-1.19-2.6456-1.19-1.0388 0-2.0157 0.42241-2.7503 1.19-1.5166 1.5848-1.5166 4.1634 0 5.7477l5.4343 4.8784c0.088853 0.093192 0.19947 0.15025 0.31503 0.17222 0.038755 0.0079912 0.077732 0.011697 0.11678 0.011697 0.15373 0 0.30772-0.061266 0.42479-0.18391l5.4343-4.8784c1.5166-1.5842 1.5166-4.1628-3.69e-5 -5.7477z",
    fill: "#323232",
    fillRule: "nonzero"
  }))))));
};
var FavouriteCallOut = styled.span.withConfig({
  displayName: "all-stores__FavouriteCallOut",
  componentId: "sc-1hh6lnf-2"
})(["visibility:hidden;background-color:", ";border-radius:6px;position:absolute;z-index:", ";margin-left:0;transition:opacity 0.3s;padding:1em;@media only screen and (min-width:", "){top:-4.2em;left:-2.3em;width:14em;height:4em;}top:-4.1em;left:-2.5em;width:15em;height:4em;::after{content:'';position:absolute;top:100%;left:20%;margin-left:0;border-width:9px;border-style:solid;border-color:", " transparent transparent transparent;}"], colours.qantasLightCyan, zIndexes.favouriteCallout, layoutSizes.desktopWidth, colours.qantasLightCyan);
var CloseFavouriteCallout = styled.span.withConfig({
  displayName: "all-stores__CloseFavouriteCallout",
  componentId: "sc-1hh6lnf-3"
})(["position:absolute;right:7px;top:3px;font-weight:bold;"]);
var AllStoresHeader = styled.h1.withConfig({
  displayName: "all-stores__AllStoresHeader",
  componentId: "sc-1hh6lnf-4"
})(["@media only screen and (max-width:", "){margin:0;height:4rem;font-size:1.375rem;line-height:4rem;padding-left:1rem;border-bottom:0.5px solid ", ";}"], layoutSizes.mobileWidth, colours.qantasBorderLightGrey);
var checkBonus = function checkBonus(bonus) {
  if (bonus) {
    var notBonus = document.querySelectorAll("[id^='notbonus']");
    // eslint-disable-next-line no-param-reassign
    notBonus.forEach(function (nb) {
      nb.style.display = 'none';
    });
    var alphabet = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
    alphabet.forEach(function (letter) {
      var storesBar = document.querySelector("[id=stores".concat(letter.toUpperCase(), "]"));
      if (!storesBar) {
        return;
      }
      var bonusForLetter = document.querySelectorAll("[id='bonus_".concat(letter, "']"));
      storesBar.style.display = bonusForLetter.length === 0 ? 'none' : 'unset';
    });
  }
};
var checkCallout = function checkCallout() {
  var firstFavButton = document.querySelector("button[class^='CardButton']");
  if (firstFavButton) {
    var calloutCookie = getFavouritesCalloutCookie();
    if (calloutCookie === null) {
      var calloutDiv = document.querySelector('#favouriteCallout');
      firstFavButton.appendChild(calloutDiv);
      if (calloutDiv) {
        calloutDiv.style.visibility = 'visible';
      }
      var cookieExpiration = new Date();
      cookieExpiration.setDate(cookieExpiration.getDate() + 1);
      cookieExpiration.setHours(0);
      cookieExpiration.setMinutes(0);
      cookieExpiration.setSeconds(0);
      setFavouritesCalloutCookie(cookieExpiration);
    }
  }
};

/* eslint-disable max-len */
var AllStores = function AllStores(_ref) {
  var resetLastInteractedTimestamp = _ref.resetLastInteractedTimestamp,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? true : _ref$loading,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? {} : _ref$error,
    _ref$merchantsAZ = _ref.merchantsAZ,
    merchantsAZ = _ref$merchantsAZ === void 0 ? [] : _ref$merchantsAZ,
    bonusCampaignItems = _ref.bonusCampaignItems,
    _ref$page = _ref.page,
    page = _ref$page === void 0 ? {} : _ref$page,
    _ref$authorized = _ref.authorized,
    authorized = _ref$authorized === void 0 ? false : _ref$authorized,
    _ref$router = _ref.router;
  _ref$router = _ref$router === void 0 ? {} : _ref$router;
  var asPath = _ref$router.asPath;
  var _useWindowDimensions = useWindowDimensions(),
    isMobile = _useWindowDimensions.isMobile;
  var _useState = useState(undefined),
    selectedLetter = _useState[0],
    setSelectedLetter = _useState[1];
  useEffect(function () {
    resetLastInteractedTimestamp();
  }, []);
  var bonus = asPath.toLowerCase().indexOf('bonus=true') > -1;
  useEffect(function () {
    checkBonus(bonus);
    checkCallout();
  }, [asPath]);
  var merchantsAZVisible = merchantsAZ.map(function (group) {
    var _group$merchants = group.merchants,
      merchants = _group$merchants === void 0 ? [] : _group$merchants;
    var merchantsVisible = merchants.filter(function (m) {
      return m.isVisible;
    });
    return _objectSpread(_objectSpread({}, group), {}, {
      merchants: merchantsVisible
    });
  });
  if (loading) {
    return __jsx(Container, null, "Loading");
  }
  if (error && error.message) {
    return __jsx(Container, null, "Error");
  }
  var metaTitle = _.get(page, 'meta.title', 'Online Shopping Offers & Earn Points');
  var metaDescription = _.get(page, 'meta.description', 'Earn Qantas Points shopping online at over 450 top brands including Myer, ebay, Adore Beauty, THE ICONIC, David Jones, Apple and more.');
  var bonusRibbons = _.get(bonusCampaignItems, ['0', 'bonusRibbons'], []);
  return __jsx(Container, {
    wideView: true,
    mobilePadding: "0"
  }, __jsx(Layout, {
    slug: "all-stores",
    title: metaTitle,
    description: metaDescription
  }, isMobile === false && __jsx(AllStoresHeader, null, "All Stores A - Z"), isMobile === false && __jsx(React.Fragment, null, __jsx("p", null, "Browse our list of brands below or curate your own Favourites Collection for easier access to shop and be notified when they\u2019re offering bonus Qantas Points."), __jsx("p", null, "Simply login and click the ", __jsx(Heart, {
    isFilled: false
  }), " on your favourite brands below and access your Favourites Collection by clicking the ", __jsx(HeartInCircle, null), " at the top of the page.")), __jsx(MerchantListNav, {
    groups: merchantsAZVisible,
    bonus: bonus,
    selectedLetter: selectedLetter,
    setSelectedLetter: setSelectedLetter
  }), isMobile === true && __jsx(AllStoresHeader, null, "All Stores A-Z"), authorized ? __jsx(FavouriteCallOut, {
    id: "favouriteCallout"
  }, __jsx("b", null, "Click here"), " to add to your Favourites Collection", __jsx(CloseFavouriteCallout, {
    onClick: function onClick(e) {
      setFavouritesCalloutCookie(config.FAVOURITES_CALLOUT_COOKIE_DAYS);
      e.target.parentNode.style.visibility = 'hidden';
    }
  }, "x")) : null, __jsx(CardWrapper, null, isMobile !== undefined && merchantsAZVisible.map(function (group) {
    var firstLetter = group.firstLetter,
      merchants = group.merchants;
    return merchants.length > 0 ? __jsx(Fragment, {
      key: firstLetter
    }, __jsx(LetterBar, null, __jsx("div", {
      id: "stores".concat(firstLetter)
    }), __jsx("span", null, firstLetter)), __jsx(MerchantList, {
      merchants: merchants,
      bonusRibbons: bonusRibbons,
      isMobile: isMobile
    })) : null;
  })), __jsx(ScrollToTop, {
    showUnder: 160,
    style: {
      zIndex: zIndexes.backToTopBtn
    }
  }, __jsx(Button, {
    primary: true,
    rounded: true
  }, "Back to top"))));
};
var merchantQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query merchantAZQuery {\n    bonusCampaignItems(first: 1) {\n      bonusRibbons {\n        color\n        backgroundColor\n        title\n        name\n      }\n    }\n    merchantsAZ {\n      firstLetter\n      merchants {\n        merchantId\n        merchantIdMCO\n        merchantIdOLM\n        merchantIdDirect\n        merchantName\n        merchantLogoSquare\n        is_elevated\n        is_new\n        isVisible\n        rebate {\n          rebate_user\n          start_date\n          end_date\n        }\n        was_rebate {\n          rebate_user\n        }\n        has_free_ship\n        has_coupon_code\n        directContent {\n          directPanelTitle\n          directPanelCopy\n          directPanelUrl\n        }\n        directOffers {\n          offerType\n          points\n          perValue\n          bespokeOffer\n          terms\n          exclusions\n          ctaLink\n          ctaName\n        }\n      }\n    }\n  }\n"])));
AllStores.getInitialProps = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
    var page;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            page = _ref2.query.page;
            return _context.abrupt("return", {
              page: page
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref3.apply(this, arguments);
  };
}();
var mapStateToProps = function mapStateToProps(_ref4) {
  var authorized = _ref4.user.authorized;
  return {
    authorized: authorized
  };
};
export default compose(connect(mapStateToProps, null), graphql(merchantQuery, {
  props: function props(_ref5) {
    var data = _ref5.data;
    return data;
  }
}), graphql(queries.resetLastInteractedTimestamp, {
  props: function props(_ref6) {
    var mutate = _ref6.mutate;
    return {
      resetLastInteractedTimestamp: mutate
    };
  }
}))(withRouter(AllStores));